const LOCAL_STORAGE_RECENTLYVIEWED_KEY = 'recentlyViewedProducts3';
const LOCAL_STORAGE_TOMORROW_DATE = 'tomorrowDate';
const LOCAL_STORAGE_CHECKEDCURRENTPRODUCTS_KEY = 'checkedCurrentProducts';
const LOCAL_STORAGE_DELIMITER_2 = ',';
var products = [];
var recentlyViewedProducts = [];
var productCount = 0;
var recentlyViewedElements = [];

const getRecentlyViewedProducts = () => {
  const recentlyViewedProducts = localStorage.getItem(LOCAL_STORAGE_RECENTLYVIEWED_KEY) || false;
  if (recentlyViewedProducts) return recentlyViewedProducts.split(LOCAL_STORAGE_DELIMITER_2);
  return [];
}
const setRecentlyViewedProducts = (array) => {
  const recentlyViewedProducts = array.join(LOCAL_STORAGE_DELIMITER_2);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_RECENTLYVIEWED_KEY, recentlyViewedProducts);
  else localStorage.removeItem(LOCAL_STORAGE_RECENTLYVIEWED_KEY);
  return recentlyViewedProducts;
}
const updateRecentlyViewedProducts = (handle) => {
  const recentlyViewedProducts = getRecentlyViewedProducts();
  const indexInRecentlyViewedProducts = recentlyViewedProducts.indexOf(handle);
  if (indexInRecentlyViewedProducts === -1) recentlyViewedProducts.push(handle);
  else recentlyViewedProducts.splice(indexInRecentlyViewedProducts, 1);
  return setRecentlyViewedProducts(recentlyViewedProducts);
}
const removeFromRecentlyViewedProducts = (handle) => {
  const recentlyViewedProducts = getRecentlyViewedProducts();
  const indexInRecentlyViewedProducts = recentlyViewedProducts.indexOf(handle);
  const recentlyViewedProductsProductRemoved = recentlyViewedProducts.slice(recentlyViewedProducts.indexOf(handle), 1);
}
const limitProductCount = () => {
  setRecentlyViewedProducts(getRecentlyViewedProducts().reverse().slice(0, 10).reverse());
}
const getProductData = (recentlyViewedProducts) => {
  $.each(recentlyViewedProducts, function(index, handle) {
    $.ajax({
      type: "GET",
      async: true,
      url: `/products/${handle}.js`,
      success: function (product) {
        products.push(
          {
            "index": index,
            "title": product.title,
            "handle": product.handle,
            "url": product.url,
            "image": product.featured_image,
            "tags": product.tags
          }
        )
      },
      error: function (xhr, ajaxOptions, thrownError) {
        //console.log(`${xhr.status} ${handle}`);
        updateRecentlyViewedProducts(handle)
      },
      dataType: "json"
    });
  })
}

const recentlyViewedProductsContains = (handle) => {
  const recentlyViewedProducts = getRecentlyViewedProducts();
  return recentlyViewedProducts.includes(handle);
}
const createRecentlyViewedItem = (index, product) => {
  const $recentlyViewedProduct = $("<div/>")
    .addClass("blockItem recentlyViewed")
    .attr('data-index', index)
    .attr("data-product-handle", product.handle);
  const $recentlyViewedProductRemove = $("<i/>")
    .addClass("fa-solid fa-xmark")
    .appendTo($recentlyViewedProduct);
  const $recentlyViewedProductLink = $("<a/>")
    .attr("href", product.url);

  const imageSRC = product.image;
  const lastIndex = imageSRC.lastIndexOf('.');
  const amendedSRC = imageSRC.substr(0, lastIndex) + '_200x' + imageSRC.substr(lastIndex);
  
  const $recentlyViewedProductImage = $("<img/>")
    .attr("src", amendedSRC)
    .appendTo($recentlyViewedProductLink);

  var productHeading = '', productSubheading = '', productType = "";
  
  $.each(product.tags, function(index, value) {
    if (value.indexOf("type_") >= 0) {
      productType = value.replace('type_', '')
    }
    else if (value.indexOf("type_") == 0) {
      productType = '';
    }
  });

  const $recentlyViewedProductTitle = $("<span/>")
    .addClass("text");
  const $recentlyViewedProductRange = $("<span/>")
    .addClass("productHeading");
  const $recentlyViewedProductType = $("<span/>")
    .addClass("productSubheading");
  
  if (product.title.indexOf("The Firm One") >= 0 ||
    product.title.indexOf("The Memory One") >= 0 ||
    product.title.indexOf("The Natural One") >= 0 ||
    product.title.indexOf("Fabb Package Deal") >= 0) {
    productHeading = product.title.split(" ");
    productSubheading = productHeading.slice(3,productHeading.length).join(" ");
    $recentlyViewedProductRange.text(`${productHeading[0]} ${productHeading[1]} ${productHeading[2]}`);
    if (productType != "") {
      $recentlyViewedProductType.text(productType);
    }
  }
  else if (product.title.indexOf("Ballad Premium") >= 0) {
    productHeading = product.title.split(" ");
    productSubheading = productHeading.slice(2,productHeading.length).join(" ");
    $recentlyViewedProductRange.text(`${productHeading[0]} ${productHeading[1]}`);
    if (productType != "") {
      $recentlyViewedProductType.text(productType);
    }
  }
  else {
    productHeading = product.title.split(" ");
    productSubheading = productHeading.slice(1,productHeading.length).join(" ");
    $recentlyViewedProductRange.text(`${productHeading[0]}`);
    if (productType != "") {
      $recentlyViewedProductType.text(productType);
    }
  }
  
  $recentlyViewedProductRange.appendTo($recentlyViewedProductTitle);
  $recentlyViewedProductType.appendTo($recentlyViewedProductTitle);
  $recentlyViewedProductTitle.appendTo($recentlyViewedProductLink);
  $recentlyViewedProductLink.appendTo($recentlyViewedProduct)
  $recentlyViewedProduct.appendTo("#recentlyViewedContainer");
}

var currentCount;
$(document).ready(function() {
  limitProductCount();
  recentlyViewedProducts = getRecentlyViewedProducts().reverse();
  getProductData(recentlyViewedProducts);
  productCount = recentlyViewedProducts.length;
  $("#recentlyViewedContainer").attr("data-child-count", productCount)

  $(document).on('click', '.blockItem.recentlyViewed .fa-xmark', function() {
    var $associatedLeftChevron = $(this).parents(".reusableCarousel").siblings(".fa-chevron-left");
    var $associatedRightChevron = $(this).parents(".reusableCarousel").siblings(".fa-chevron-right");
    updateRecentlyViewedProducts($(this).parent('.blockItem.recentlyViewed').attr("data-product-handle"));
    $(this).parent('.blockItem.recentlyViewed').remove();
    currentCount = $("#recentlyViewedContainer .blockItem.recentlyViewed").length;
    if (getItemsToShow($("#recentlyViewedContainer")) >= currentCount) {
      $associatedLeftChevron.addClass('disabled');
      $associatedRightChevron.addClass('disabled');
      $("#recentlyViewedContainer").css({"transform": "0%", "transition-duration": "500ms"});
    }
    $("#recentlyViewedContainer").attr("data-child-count", currentCount);
  });
  
  $(document).on('click', '#clearRecentlyViewedItems', function() {
    setRecentlyViewedProducts([]);
    $(".shopify-section.index-section:has('#recentlyViewedContainer')").remove();
  });
  
  $(document).ajaxStop(function() {
    const sortedProducts = products.sort(function(a, b) {
      const indexA = a.index, indexB = b.index;
      if (indexA < indexB) return -1;
      if (indexA > indexB) return 1;
      return 0;
    });
    $.each(sortedProducts, function(index, product) {
      createRecentlyViewedItem(index, product)
    })
    $(".shopify-section.index-section:has(#recentlyViewedContainer)").show();
  });
});